<script>
import { post, get } from '@/api/api'

export default {
  name: "patientProfileDetails",
  props: {
    patientDetail: {
      type: Object,
      default: () => null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editMode: false,
      cityList: [], // 级联选择的城市数据
      cityCode: [], // 级联选择的值
      nationnalityList: [], // 民族字典
      marriageTypeList: [], // 婚姻状态字典
      jobTypeList: [], // 职业字典
      calculatedAge: { ageYear: 0, ageMonth: 0, ageDays: 0 }, // 根据生日计算的年龄
      patientInfo: {
        name: '',
        gender: '',
        idNumber: '',
        phoneNumber: '',
        emergencyPhone:"",
        createTime: '',
        idCard: '',
        birthday: '',
        nation: '',
        address: '',
        provinceCode: '', // 省份代码
        cityCode: '', // 城市代码
        districtCode: '', // 区县代码
        occupation: '',
        weight: '',
        height: '', // 身高字段
        marriage: '',
        hospitalName: '',
        visitDate: '',
        outpatientCount: 0
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        districtCode: [{ required: true, message: '请选择现居住地', trigger: 'change' }],
        occupation: [{ required: true, message: '请输入职业', trigger: 'blur' }],
        weight: [{ required: true, message: '请输入体重', trigger: 'blur' }, { pattern: /^\d+(\.\d+)?$/, message: '体重必须为数字', trigger: 'blur' }],
        // 非必填项
        idCard: [{ required: false, message: '请输入身份证号', trigger: 'blur' }],
        nation: [{ required: false, message: '请输入民族', trigger: 'blur' }],
        marriage: [{ required: false, message: '请选择婚姻状况', trigger: 'change' }],
        phoneNumber: [
            { required: false, message: '请输入电话号码', trigger: 'blur' }, { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' },
          {validator: (rule, value, callback) => {
              if (!this.patientInfo.phoneNumber && !this.patientInfo.emergencyPhone) {
                callback(new Error('手机号与紧急联系电话必填一项'));
              } else {
                callback();
              }
            }},
          {validator: (rule, value, callback) => {
              if ((this.patientInfo.phoneNumber && this.patientInfo.emergencyPhone) && this.patientInfo.phoneNumber  === this.patientInfo.emergencyPhone) {
                callback(new Error('手机号与紧急联系电话不能相同'));
              } else {
                callback();
              }
            }},
        ],
        emergencyPhone:[{ required: false, message: '请输入电话号码', trigger: 'blur' }, { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }, {validator: (rule, value, callback) => {
            if (!this.patientInfo.phoneNumber && !this.patientInfo.emergencyPhone) {
              callback(new Error('手机号与紧急联系电话必填一项'));
            } else {
              callback();
            }
          }}, {validator: (rule, value, callback) => {
            if ((this.patientInfo.phoneNumber && this.patientInfo.emergencyPhone) && this.patientInfo.phoneNumber  === this.patientInfo.emergencyPhone) {
              callback(new Error('手机号与紧急联系电话不能相同'));
            } else {
              callback();
            }
          }},],
        birthday: [
          { required: false, message: '请选择出生日期', trigger: 'change' },
          { 
            validator: (rule, value, callback) => {
              if (value) {
                const birthDate = new Date(value);
                const today = new Date();
                if (birthDate > today) {
                  callback(new Error('出生日期不能晚于今天'));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            }, 
            trigger: 'change' 
           }
        ],
        height: [
          { required: false, message: '请输入身高', trigger: 'blur' },
          { pattern: /^\d+(\.\d+)?$/, message: '身高必须为数字', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              if (value) {
                const heightNum = parseFloat(value);
                if (heightNum < 30 || heightNum > 300) {
                  callback(new Error('身高应在30-300cm之间'));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            }, 
            trigger: 'blur' 
          }
        ]
      }
    };
  },
  computed: {
    // 计算显示的患者信息
    displayPatientInfo() {
      if (!this.patientDetail) {
        return this.patientInfo; // 返回默认数据
      }
      
      return {
        name: this.patientDetail.name || '',
        gender: this.getGenderDisplay(this.patientDetail),
        ageYear: this.calculateDisplayAge(this.patientDetail),
        idNumber: this.patientDetail.caseNumber || '',
        phoneNumber: this.patientDetail.phoneNumber || '',
        emergencyPhone:this.patientDetail.emergencyPhone || '',
        archiveNumber: this.patientDetail.caseNumber || '',
        createTime: this.patientDetail.createTime,
        idCard: this.patientDetail.idNumber || '',
        birthday: this.patientDetail.birthday,
        nation: this.getNationDisplay(this.patientDetail),
        address: this.getFullAddress(this.patientDetail),
        occupation: this.patientDetail.job || '',
        weight: this.patientDetail.weight || '',
        height: this.patientDetail.height || '',
        marriage: this.getMarriageDisplay(this.patientDetail),
        hospitalName: this.patientDetail.hospitalName || '',
        visitDate: this.patientDetail.visitDate,
        outpatientCount: this.patientDetail.outpatientCount || 0
      };
    }
  },
  watch: {
    patientDetail: {
      handler(newVal) {
        if (newVal) {
          // 当接收到新的患者详情数据时，更新patientInfo
          this.patientInfo = { ...this.displayPatientInfo };
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    extractDateFromDateTime(dateTimeString) {
      // 方法1: 使用字符串分割
      return dateTimeString.split(' ')[0];
    },
    // 获取字典数据
    getConstantList() {
      get('/common/constantItem/getConstantList').then(res => {
        console.log('字典数据:', res.data.data)
        this.nationnalityList = res.data.data.Nationnality
        this.marriageTypeList = res.data.data.MarriageType
        this.jobTypeList = res.data.data.JobType
      }).catch(error => {
        console.error('获取字典数据失败:', error)
      })
    },
    // 计算显示年龄
    calculateDisplayAge(patient) {
      if (!patient) return '';
      
      const { ageYear, ageMonth, ageDays } = patient;
      let ageStr = '';
      
      if (ageYear > 0) {
        ageStr += `${ageYear}岁`;
      }
      if (ageMonth > 0) {
        ageStr += `${ageMonth}月`;
      }
      if (ageDays > 0 && ageYear === 0 && ageMonth === 0) {
        ageStr += `${ageDays}天`;
      }
      
      return ageStr || '';
    },

    // 提取纯数字年龄（用于编辑）
    extractAgeNumber(patient) {
      if (!patient) return '';
      
      // 优先使用ageYear字段
      if (patient.ageYear !== undefined && patient.ageYear !== null) {
        return patient.ageYear.toString();
      }
      
      // 如果没有ageYear，尝试从其他字段解析
      if (patient.ageYear) {
        const ageMatch = patient.ageYear.toString().match(/(\d+)/);
        if (ageMatch) {
          return ageMatch[1];
        }
      }
      
      return '';
    },

    // 根据生日计算年龄
    calculateAgeFromBirthday(birthday) {
      if (!birthday) {
        return { ageYear: 0, ageMonth: 0, ageDays: 0 };
      }

      const birthDate = new Date(birthday);
      const today = new Date();
      
      let ageYear = today.getFullYear() - birthDate.getFullYear();
      let ageMonth = today.getMonth() - birthDate.getMonth();
      let ageDays = today.getDate() - birthDate.getDate();

      // 如果天数为负，从月份借一个月
      if (ageDays < 0) {
        ageMonth--;
        const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        ageDays += lastMonth.getDate();
      }

      // 如果月份为负，从年份借一年
      if (ageMonth < 0) {
        ageYear--;
        ageMonth += 12;
      }

      return {
        ageYear: Math.max(0, ageYear),
        ageMonth: Math.max(0, ageMonth),
        ageDays: Math.max(0, ageDays)
      };
    },

    // 处理生日变化事件
    onBirthdayChange(birthday) {
      if (birthday) {
        const ageInfo = this.calculateAgeFromBirthday(birthday);
        // 更新计算出的年龄字段（这些字段不显示，但会在保存时使用）
        this.calculatedAge = ageInfo;
      } else {
        this.calculatedAge = { ageYear: 0, ageMonth: 0, ageDays: 0 };
      }
    },

    // 获取性别显示文本
    getGenderDisplay(patient) {
      if (!patient) return '';
      
      // 优先使用genderName
      if (patient.genderName) {
        return patient.genderName;
      }
      
      // 如果没有genderName，根据gender代码转换
      const gender = patient.gender;
      if (gender === 'NAN') return '男';
      if (gender === 'NV') return '女';
      
      return gender || '';
    },

    // 获取民族显示文本
    getNationDisplay(patient) {
      if (!patient) return '';
      
      // 优先使用nationnalityName
      if (patient.nationnalityName) {
        return patient.nationnalityName;
      }
      
      // 如果没有nationnalityName，根据nationnality代码查找对应的名称
      const nationCode = patient.nationnality;
      if (nationCode && this.nationnalityList) {
        const nationItem = this.nationnalityList.find(item => item.code === nationCode);
        if (nationItem) {
          return nationItem.name;
        }
      }
      
      return nationCode || '';
    },

    // 获取婚姻状况显示文本
    getMarriageDisplay(patient) {
      if (!patient) return '';
      
      // 优先使用marriageName
      if (patient.marriageName) {
        return patient.marriageName;
      }
      
      // 如果没有marriageName，根据marriage代码查找对应的名称
      const marriageCode = patient.marriage;
      if (marriageCode && this.marriageTypeList) {
        const marriageItem = this.marriageTypeList.find(item => item.code === marriageCode);
        if (marriageItem) {
          return marriageItem.name;
        }
      }
      
      return marriageCode || '';
    },
    
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '';
      try {
        const date = new Date(dateStr);
        return date.toLocaleDateString('zh-CN');
      } catch (error) {
        return dateStr;
      }
    },
    
    // 获取完整地址
    getFullAddress(patient) {
      if (!patient) return '';
      
      const { provinceName, cityName, districtName } = patient;
      const addressParts = [provinceName, cityName, districtName].filter(Boolean);
      return addressParts.join('');
    },
    startEdit() {
      console.log('开始编辑，patientDetail:', this.patientDetail);
      console.log('patientDetail类型:', typeof this.patientDetail);
      console.log('patientDetail是否为null:', this.patientDetail === null);
      
      this.editMode = true;
      
      // 将patientDetail的数据复制到patientInfo中进行编辑
      if (this.patientDetail) {
        console.log('patientDetail数据:', this.patientDetail);
        
        this.patientInfo = {
          ...this.patientInfo,
          name: this.patientDetail.name || '',
          gender: this.patientDetail.gender || '', // 直接使用gender代码（NAN/NV）
          phoneNumber: this.patientDetail.phoneNumber || '',
          emergencyPhone:this.patientDetail.emergencyPhone || '',
          idCard: this.patientDetail.idNumber || '',
          birthday: this.patientDetail.birthday || '',
          nation: this.patientDetail.nationnality || this.patientDetail.nation || '', // 使用民族代码
          occupation: this.patientDetail.job || this.patientDetail.occupation || '',
          weight: this.patientDetail.weight || '',
          height: this.patientDetail.height || '',
          marriage: this.patientDetail.marriage || '', // 使用婚姻状况代码
          // 地址相关字段 - 尝试多种可能的字段名
          provinceCode: this.patientDetail.provinceCode || this.patientDetail.province || '',
          cityCode: this.patientDetail.cityCode || this.patientDetail.city || '',
          districtCode: this.patientDetail.districtCode || this.patientDetail.district || ''
        };
        
        // 如果有生日，计算年龄信息
        if (this.patientInfo.birthday) {
          this.onBirthdayChange(this.patientInfo.birthday);
        }
        
        console.log('初始化后的patientInfo:', this.patientInfo);
        console.log('字段映射详情:', {
          gender: {
            genderName: this.patientDetail.genderName,
            gender: this.patientDetail.gender,
            final: this.patientInfo.gender
          },
          nation: {
            nationnalityName: this.patientDetail.nationnalityName,
            nationnality: this.patientDetail.nationnality,
            nation: this.patientDetail.nation,
            final: this.patientInfo.nation
          },
          marriage: {
            marriageName: this.patientDetail.marriageName,
            marriage: this.patientDetail.marriage,
            final: this.patientInfo.marriage
          },
          occupation: {
            job: this.patientDetail.job,
            occupation: this.patientDetail.occupation,
            final: this.patientInfo.occupation
          }
        });
        
        // 初始化级联选择的值
        const provinceCode = this.patientInfo.provinceCode;
        const cityCode = this.patientInfo.cityCode;
        const districtCode = this.patientInfo.districtCode;
        
        console.log('检查地址字段:', {
          provinceCode: this.patientInfo.provinceCode,
          cityCode: this.patientInfo.cityCode,
          districtCode: this.patientInfo.districtCode
        });
        
        if (provinceCode && cityCode && districtCode) {
          this.cityCode = [provinceCode, cityCode, districtCode];
          console.log('初始化级联选择器值:', this.cityCode);
        } else {
          this.cityCode = [];
          console.log('级联选择器值为空，地址字段不完整:', { provinceCode, cityCode, districtCode });
        }
      }
    },
    cancelEdit() {
      this.editMode = false;
      // 可添加重置逻辑
    },
    saveEdit() {
      this.$refs.patientForm.validate((valid) => {
        if (valid) {
          // 构建保存的患者数据，参考createOreditPatient的数据结构
          const saveData = {
            // 基本信息
            name: this.patientInfo.name,
            gender: this.patientInfo.gender, // 性别字段直接使用（已经是NAN/NV格式）
            phoneNumber: this.patientInfo.phoneNumber,
            emergencyPhone:this.patientDetail.emergencyPhone || '',
            idNumber: this.patientInfo.idCard,
            birthday: this.patientInfo.birthday,
            nationnality: this.patientInfo.nation,
            job: this.patientInfo.occupation,
            weight: this.patientInfo.weight,
            height: this.patientInfo.height, // 身高字段
            marriage: this.patientInfo.marriage,
            // 地址相关字段
            provinceCode: this.patientInfo.provinceCode,
            cityCode: this.patientInfo.cityCode,
            districtCode: this.patientInfo.districtCode,
            // 年龄字段 - 使用计算出的年龄
            ageYear: this.calculatedAge.ageYear,
            ageMonth: this.calculatedAge.ageMonth,
            ageDays: this.calculatedAge.ageDays,
            // 如果有患者ID，则为更新操作
            ...(this.patientDetail && this.patientDetail.id && { id: this.patientDetail.id }),
            // 如果有案例号，保留案例号
            ...(this.patientDetail && this.patientDetail.caseNumber && { caseNumber: this.patientDetail.caseNumber })
          };

          console.log('保存患者数据:', saveData);
          console.log('地址字段详情:', {
            provinceCode: this.patientInfo.provinceCode,
            cityCode: this.patientInfo.cityCode,
            districtCode: this.patientInfo.districtCode,
            cityCodeArray: this.cityCode
          });

          post('/outpatientDoctor/patient/save', saveData).then(res => {
            console.log('保存响应:', res);
            if (res.data.code === 200) {
              this.$message.success('保存成功！');
              this.editMode = false;
              
              // 更新本地patientDetail数据以正确回显
              if (this.patientDetail) {
                // 更新patientDetail中的字段
                this.patientDetail.name = saveData.name;
                this.patientDetail.gender = saveData.gender;
                this.patientDetail.phoneNumber = saveData.phoneNumber;
                this.patientDetail.idNumber = saveData.idNumber;
                this.patientDetail.birthday = saveData.birthday;
                this.patientDetail.nationnality = saveData.nationnality;
                this.patientDetail.job = saveData.job;
                this.patientDetail.weight = saveData.weight;
                this.patientDetail.height = saveData.height;
                this.patientDetail.marriage = saveData.marriage;
                this.patientDetail.provinceCode = saveData.provinceCode;
                this.patientDetail.cityCode = saveData.cityCode;
                this.patientDetail.districtCode = saveData.districtCode;
                // 更新年龄字段
                this.patientDetail.ageYear = saveData.ageYear;
                this.patientDetail.ageMonth = saveData.ageMonth;
                this.patientDetail.ageDays = saveData.ageDays;
              }
              
              // 触发父组件刷新患者详情
              this.$emit('patient-updated', saveData);
            } else {
              this.$errorHandler.showError({ msg: res.data.message }, {
                defaultMessage: '保存失败'
              });
            }
          }).catch(err => {
            this.$errorHandler.showError(err, {
              defaultMessage: '保存失败，请稍后重试'
            });
          });
        } else {
          this.$message.warning('请检查输入信息');
          return false;
        }
      });
    },
    
    // 级联选择变更处理
    changeCity(val) {
      console.log('级联选择变更:', val);
      if (val && val.length === 3) {
        this.patientInfo.provinceCode = val[0];
        this.patientInfo.cityCode = val[1];
        this.patientInfo.districtCode = val[2];
        console.log('设置地址代码:', {
          provinceCode: val[0],
          cityCode: val[1],
          districtCode: val[2]
        });
      } else {
        this.patientInfo.provinceCode = '';
        this.patientInfo.cityCode = '';
        this.patientInfo.districtCode = '';
        console.log('清空地址代码');
      }
      console.log('更新后的patientInfo:', this.patientInfo);
    },
    
    // 获取城市数据
    getCity() {
      get('/common/levelMetadata/getMetadataList').then(res => {
        this.cityList = this.transformData(res.data.data.AreaCode);
      }).catch(err => {
        console.error('获取城市数据失败:', err);
      });
    },
    
    // 转换数据结构
    transformData(data) {
      if (!Array.isArray(data)) {
        return [];
      }

      return data.map(item => {
        const newItem = {
          label: item.name,
          value: item.code,
        };

        // 递归处理子项
        if (item.childList && item.childList.length > 0) {
          newItem.children = this.transformData(item.childList);
        } else {
          newItem.children = null;
        }

        // 保留其他原始属性（如id）
        for (const key in item) {
          if (key !== 'name' && key !== 'code' && key !== 'childList') {
            newItem[key] = item[key];
          }
        }

        return newItem;
      });
    },
    

  },
  
  mounted() {
    this.getCity();
    this.getConstantList();
  }
}
</script>

<template>
<div class="patientProfileDetails">
  <div class="patientInfoCard">
    <!-- 加载状态 -->
    <div v-if="loading" 
         class="loading-container"
         v-loading="loading" 
         element-loading-text="正在加载患者详情..."
         element-loading-background="rgba(255, 255, 255, 0.8)">
    </div>
    
    <!-- 无数据状态 -->
    <div v-else-if="!patientDetail && !loading" class="no-data-container">
      <div class="no-data-content">
        <i class="el-icon-user" style="font-size: 48px; color: #ccc;"></i>
        <p style="color: #999; margin-top: 16px;">请选择患者查看详情</p>
      </div>
    </div>
    
    <!-- 患者详情内容 -->
    <el-form v-else ref="patientForm" :model="patientInfo" :rules="rules" class="patient-info-display">
      <div class="info-header">
        <div class="info-left">
          <span v-if="!editMode" class="patient-name">{{ displayPatientInfo.name }}</span>
          <el-form-item style="width: 150px" v-else prop="name" class="inline-form-item">
            <el-input v-model="patientInfo.name" size="small" class="inline-input name-input"></el-input>
          </el-form-item>

          <span v-if="!editMode" :class="['patient-gender', displayPatientInfo.gender === '男' ? 'male' : 'female']">{{ displayPatientInfo.gender }}</span>
          <el-form-item  style="width: 100px" v-else prop="gender" class="inline-form-item">
            <el-select v-model="patientInfo.gender" size="small" class="inline-input gender-input">
              <el-option label="男" value="NAN"></el-option>
              <el-option label="女" value="NV"></el-option>
            </el-select>
          </el-form-item>

          <span v-if="!editMode" class="patient-age">{{ displayPatientInfo.ageYear }}</span>
          <el-form-item style="width: 300px" v-else prop="birthday"  label="年龄" class="inline-form-item">
            <el-date-picker
                v-model="patientInfo.birthday"
                type="date"
                size="small"
                class="inline-input birthday-input"
                placeholder="选择生日"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="onBirthdayChange">
            </el-date-picker>
          </el-form-item>

          <span v-if="!editMode" class="patient-phone">{{ displayPatientInfo.phoneNumber || displayPatientInfo.emergencyPhone }}</span>
          <el-form-item style="width: 300px" v-else prop="phoneNumber" class="inline-form-item" label="手机号" label-width="100px">
            <el-input v-model="patientInfo.phoneNumber" size="small" class="inline-input phone-input" placeholder="手机号"></el-input>
          </el-form-item>
          <el-form-item style="width: 300px" v-if="editMode"  prop="emergencyPhone" class="inline-form-item" label="紧急电话" label-width="100px">
            <el-input v-model="patientInfo.emergencyPhone" size="small" class="inline-input phone-input" placeholder="紧急电话"></el-input>
          </el-form-item>
        </div>

        <div class="action-buttons">
          <el-button v-if="!editMode" type="primary" style="width: 100px;height: 35px;"  @click="startEdit">修改</el-button>
          <el-button v-if="editMode" @click="cancelEdit" style="width: 100px;height: 35px;background-color: rgba(236,236,236,0.8);color: #000">取消</el-button>
          <el-button v-if="editMode" type="primary" style="width: 100px;height: 35px;" @click="saveEdit">保存</el-button>
        </div>
      </div>
      <div class="info-section">
        <div class="section-label">门诊</div>
        <div class="section-number">{{ displayPatientInfo.outpatientCount }}</div>
        <div class="section-detail">
          <div style="color: #000;font-weight: 700">最近就诊：</div>
          <div v-if="displayPatientInfo.visitDate && displayPatientInfo.hospitalName">
            {{extractDateFromDateTime(displayPatientInfo.visitDate)}} {{ displayPatientInfo.hospitalName }}
          </div>
          <div v-else style="color: #999;">暂无就诊记录</div>
        </div>
      </div>
      <div class="info-grid">
         <div class="info-row">
           <div class="info-item">
             <span class="label">档案号：</span>
             <span class="value">{{ displayPatientInfo.archiveNumber }}</span>
           </div>
           <div class="info-item">
             <span class="label">创建时间：</span>
             <span class="value">{{ displayPatientInfo.createTime }}</span>
           </div>
         </div>
         <div class="info-row">
           <div class="info-item">
             <span class="label">身份证：</span>
             <span v-if="!editMode" class="value">{{ displayPatientInfo.idCard }}</span>
             <el-form-item v-else prop="idCard" class="inline-form-item">
               <el-input v-model="patientInfo.idCard" size="small" class="inline-input"></el-input>
             </el-form-item>
           </div>
           <div class="info-item">
             <span class="label">生日：</span>
             <span v-if="!editMode" class="value">{{ displayPatientInfo.birthday }}</span>
             <el-form-item v-else prop="birthday" class="inline-form-item">
               <el-date-picker v-model="patientInfo.birthday" type="date" size="small" class="inline-input"></el-date-picker>
             </el-form-item>
           </div>
         </div>
         <div class="info-row">
           <div class="info-item">
             <span class="label">民族：</span>
             <span v-if="!editMode" class="value">{{ displayPatientInfo.nation }}</span>
             <el-form-item v-else prop="nation" class="inline-form-item">
               <el-select v-model="patientInfo.nation" size="small" class="inline-input" placeholder="请选择民族">
                 <el-option
                   v-for="item in nationnalityList"
                   :key="item.code"
                   :label="item.name"
                   :value="item.code">
                 </el-option>
               </el-select>
             </el-form-item>
           </div>
           <div class="info-item">
             <span class="label">现居住址：</span>
             <span v-if="!editMode" class="value">{{ displayPatientInfo.address }}</span>
             <el-form-item v-else prop="cityCode" class="inline-form-item">
               <el-cascader
                 v-model="cityCode"
                 :options="cityList"
                 placeholder="请选择现居住地"
                 size="small"
                 class="inline-input"
                 @change="changeCity"
                 style="width: 200px;">
               </el-cascader>
             </el-form-item>
           </div>
         </div>
         <div class="info-row">
           <div class="info-item">
             <span class="label">职业：</span>
             <span v-if="!editMode" class="value">{{ displayPatientInfo.occupation }}</span>
             <el-form-item v-else prop="occupation" class="inline-form-item">
               <el-select v-model="patientInfo.occupation" size="small" class="inline-input" placeholder="请选择职业">
                 <el-option
                   v-for="item in jobTypeList"
                   :key="item.code"
                   :label="item.name"
                   :value="item.code">
                 </el-option>
               </el-select>
             </el-form-item>
           </div>
           <div class="info-item">
             <span class="label">体重（kg）：</span>
             <span v-if="!editMode" class="value">{{ displayPatientInfo.weight }}</span>
             <el-form-item v-else prop="weight" class="inline-form-item">
               <el-input v-model="patientInfo.weight" size="small" class="inline-input"></el-input>
             </el-form-item>
           </div>
         </div>
         <div class="info-row">
           <div class="info-item">
             <span class="label">身高（cm）：</span>
             <span v-if="!editMode" class="value">{{ displayPatientInfo.height }}</span>
             <el-form-item v-else prop="height" class="inline-form-item">
               <el-input v-model="patientInfo.height" size="small" class="inline-input" placeholder="请输入身高"></el-input>
             </el-form-item>
           </div>
           <div class="info-item">
             <span class="label">婚姻：</span>
             <span v-if="!editMode" class="value">{{ displayPatientInfo.marriage }}</span>
             <el-form-item v-else prop="marriage" class="inline-form-item">
               <el-select v-model="patientInfo.marriage" size="small" class="inline-input" placeholder="请选择婚姻状况">
                 <el-option
                   v-for="item in marriageTypeList"
                   :key="item.code"
                   :label="item.name"
                   :value="item.code">
                 </el-option>
               </el-select>
             </el-form-item>
           </div>

         </div>
       </div>
    </el-form>
  </div>
</div>
</template>

<style lang="less" scoped>
.patientProfileDetails {
  padding: 10px;
  height: calc(100vh - 160px);
  width: 100%;
  box-sizing: border-box;
  .patientInfoCard {
    height: 96%;
    width: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 20px;
    overflow: hidden;
    position: relative;
    //border: 1px solid red;
    
    .loading-container {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.8);
      z-index: 10;
    }
    
    .no-data-container {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      
      .no-data-content {
        text-align: center;
        color: #999;
      }
    }
    .patient-info-display {
      .info-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        padding-bottom: 20px;
        padding-right: 40px;
        border-bottom: 1px solid #eee;
        gap: 15px;

        .info-left{
          display: flex;
          align-items: center;
          gap: 15px;
          flex-wrap: wrap;
          .patient-name {
            font-size: 18px;
            font-weight: bold;
            color: #333;
          }

          .patient-gender {
            color: white;
            width: 40px;
            border-radius: 3px;
            font-size: 12px;
            min-width: 24px;
            text-align: center;
            line-height: 18px;
          }

          .patient-gender.male {
            background-color: #1890ff;
          }

          .patient-gender.female {
            background-color: #F56C6C;
          }

          .patient-age {
            color: #666;
            font-size: 14px;
          }

          .patient-phone {
            color: #666;
            font-size: 14px;
          }

          .patient-id {
            color: #666;
            font-size: 14px;
            margin-right: auto;
          }
        }


        .action-buttons {
          display: flex;
          gap: 10px;

          .modify-btn {
            background-color: #50c878;
            color: #fff;
            height: 28px;
            padding: 0 12px;
            font-size: 12px;
          }

          .el-button {
            height: 28px;
            padding: 0 12px;
            font-size: 12px;
            background-color: #50c878;
            color: #fff;
            border: none;
          }
        }
      }

      .info-section {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .section-label {
          background-color: #1890ff;
          color: white;
          padding: 4px 8px;
          border-radius: 3px;
          font-size: 12px;
          margin-right: 10px;
        }

        .section-number {
          font-size: 18px;
          font-weight: bold;
          color: #333;
          margin-right: 15px;
          line-height: 18px;
        }

        .section-detail {
          color: #666;
          font-size: 14px;
          display: flex;
          align-items: center;
        }
      }

      .info-grid {
        .info-row {
          display: flex;
          margin-bottom: 20px;
          gap: 40px;

          .info-item {
            flex: 1;
            display: flex;
            align-items: center;
            min-height: 32px;

            .label {
              color: #666;
              min-width: 90px;
              margin-right: 10px;
              font-size: 14px;
              white-space: nowrap;
            }

            .value {
              color: #333;
              font-size: 14px;
              flex: 1;
            }
          }
        }
      }

      .inline-input {
        flex: 1;

        /deep/ .el-input__inner {
          border: 1px solid #d9d9d9;
          background: #fff;
          padding: 4px 11px;
          height: 31px;
          line-height: 20px;
          font-size: 14px;
          color: #333;
          border-radius: 4px;
          transition: all 0.3s;
          padding-left: 30px;
        }

        /deep/ .el-input__inner:focus {
          border-color: #409eff;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
        }

        /deep/ .el-input__inner:hover {
          border-color: #409eff;
        }
      }

      .name-input {
        min-width: 120px;
        max-width: 150px;

        /deep/ .el-input__inner {
          font-size: 18px !important;
          font-weight: bold !important;
          height: 31px !important;
          line-height: 16px !important;
          padding: 4px 8px !important;
        }
      }

      .gender-input {
          min-width: 80px;
          max-width: 100px;

          /deep/ .el-input__inner {
            font-size: 12px !important;
            height: 31px !important;
            line-height: 16px !important;
            text-align: center !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 4px 8px !important;
          }

          /deep/ .el-input__suffix {
            right: 5px;
            top: 50%;
            transform: translateY(-50%);
          }
        }

        .inline-form-item {
          margin: 0;
          display: inline-flex;
          align-items: center;
          width: 100%;
          /deep/ .el-form-item__content {
            margin-left: 0 !important;
            line-height: normal;
            display: flex;
            align-items: center;
            width: 100%;
          }

          /deep/ .el-form-item__error {
            position: absolute;
            top: 100%;
            left: 0;
            font-size: 12px;
            color: #f56c6c;
            line-height: 1;
            padding-top: 2px;
          }
        }

        .info-header .inline-form-item {
          height: 24px;
          align-items: center;
          vertical-align: middle;
        }

        .info-header {
          align-items: center;
        }

        .info-header > * {
          vertical-align: middle;
          line-height: 24px;
        }
    }
  }
}
.el-select {
  flex: 1;

  /deep/ .el-input__inner {
    border: 1px solid #d9d9d9;
    background: #fff;
    padding: 4px 11px;
    height: 28px;
    line-height: 20px;
    font-size: 14px;
    color: #333;
    border-radius: 4px;
    transition: all 0.3s;
  }

  /deep/ .el-input__inner:focus {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }

  /deep/ .el-input__inner:hover {
    border-color: #409eff;
  }
}

.el-date-picker {
  flex: 1;
  max-width: 200px;

  /deep/ .el-input__inner {
    border: 1px solid #d9d9d9;
    background: #fff;
    padding: 4px 11px;
    height: 28px;
    line-height: 20px;
    font-size: 14px;
    color: #333;
    border-radius: 4px;
    transition: all 0.3s;
  }

  /deep/ .el-input__inner:focus {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }

  /deep/ .el-input__inner:hover {
    border-color: #409eff;
  }
}
/deep/ .el-form-item__label {
  min-width:50px;
}

.loading-container {
  min-height: 200px;
  position: relative;
}
</style>